import { Stack, Typography } from "@mui/material";
import { ConfirmDialog } from "Components/Shared/Dialogs/ConfirmDialog";
import { useViewerDisclosure } from "Hooks/Social/useViewerDisclosure";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Social.PublicProfile;

export type Props = {
  isOpen: boolean;
  /** The counterpart's handle — who the caller is about to become mutual followers with. */
  handle: string | null | undefined;
  /** The counterpart's tier: a Lite persona is disclosed nothing, so the name sentence is dropped. */
  isCounterpartFullMoone: boolean | undefined;
  confirmButtonText: string;
  handleResult: (wasConfirmed: boolean) => void;
};

/**
 * Confirms an action that makes the caller and the counterpart mutual followers — following back,
 * or approving a request from someone the caller already follows. A mutual follow is the only
 * trust between Customers (Rules v2, C2): it opens both inboxes, accepts any message request
 * between them, allows direct group adds and — for a private caller — discloses their real name,
 * so it is never granted by a tap that reads like a plain follow (decision 2026-10-20). The name
 * arm is Full Moone on both sides (product matrix 2026-10-21): a Lite caller discloses nothing
 * and a Lite counterpart is disclosed nothing, so the sentence is shown only when it is true.
 * Hosts drive it through useMutualFollowConfirm.
 */
export const MutualFollowConfirmDialog = ({
  isOpen,
  handle,
  isCounterpartFullMoone,
  confirmButtonText,
  handleResult,
}: Props) => {
  const { t } = useResource();
  const { disclosesName } = useViewerDisclosure();
  // Only a private caller's name becomes visible; a public one already shows it to everyone.
  const isNameDisclosed = disclosesName && isCounterpartFullMoone === true;

  return (
    <ConfirmDialog
      isOpen={isOpen}
      modalTitle={t(RESOURCES.MutualConfirmTitle, { handle })}
      modalContent={
        <Stack gap={1}>
          <Typography>{t(RESOURCES.MutualConfirmInbox)}</Typography>
          {isNameDisclosed && (
            <Typography>
              {t(RESOURCES.MutualConfirmName, { handle })}
            </Typography>
          )}
        </Stack>
      }
      confirmButtonText={confirmButtonText}
      handleResult={handleResult}
    />
  );
};
